export enum AuthenticationServiceProvider {
    Assa = 12,
    Sura = 13,
    Google = 14,
    Cliniweb = 33
}
